export enum ConfidentialityLevelClassificationIdentifier {
  PUBLIC = 'public',
  RESTRICTED = 'restricted',
}
